import { useEffect, useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import Card from '../../Card/Card';
import TabActionButtons from '../../FormElements/TabActionButtons/TabActionButtons';
import styles from './TabSections.module.css';

const SearchSettings = ({ onSave, onReset, settingsData, onSettingsChange, showToast }) => {
  const [settings, setSettings] = useState({
    hvnly_searchResultsPerPage: 12,
    hvnly_enableAjaxSearch: true,
    hvnly_searchPlaceholder: __('Search properties...', 'havenlytics'),
    hvnly_enableLocationSearch: true,
    hvnly_searchRadius: 25
  });

  useEffect(() => {
    if (settingsData && Object.keys(settingsData).length > 0) {
      setSettings(prev => ({ ...prev, ...settingsData }));
    }
  }, [settingsData]);

  const handleInputChange = (field, value) => {
    const newSettings = { ...settings, [field]: value };
    setSettings(newSettings);
    if (onSettingsChange) {
      onSettingsChange(newSettings);
    }
  };

  const handleSave = async () => {
    if (onSave) {
      await onSave(settings);
      return true;
    }
    return false;
  };

  const handleReset = async () => {
    const defaultSettings = {
      hvnly_searchResultsPerPage: 12,
      hvnly_enableAjaxSearch: true,
      hvnly_searchPlaceholder: __('Search properties...', 'havenlytics'),
      hvnly_enableLocationSearch: true,
      hvnly_searchRadius: 25
    };
    setSettings(defaultSettings);
    if (onSettingsChange) {
      onSettingsChange(defaultSettings);
    }
    if (onReset) {
      await onReset();
      return true;
    }
    return false;
  };

  return (
    <div className={`${styles['hvnly-settings-api__content']} ${styles['hvnly-settings-api__content--active']}`} id="search">
      <h2>{__('Search Settings', 'havenlytics')}</h2>

      <Card title={__("Search Configuration", "havenlytics")} icon="fas fa-search" collapsible>
        <div className={styles['hvnly-settings-api__form-group']}>
          <label className={styles['hvnly-settings-api__form-label']}>
            {__("Search Results Per Page", "havenlytics")}
          </label>
          <input
            type="number"
            className={styles['hvnly-settings-api__form-control']}
            value={settings.hvnly_searchResultsPerPage}
            onChange={(e) => handleInputChange('hvnly_searchResultsPerPage', parseInt(e.target.value))}
            min="1"
            max="100"
            id="hvnly_searchResultsPerPage"
          />
        </div>

        <div className={styles['hvnly-settings-api__form-group']}>
          <label className={styles['hvnly-settings-api__form-label']}>
            {__("Search Placeholder Text", "havenlytics")}
          </label>
          <input
            type="text"
            className={styles['hvnly-settings-api__form-control']}
            value={settings.hvnly_searchPlaceholder}
            onChange={(e) => handleInputChange('hvnly_searchPlaceholder', e.target.value)}
            placeholder={__("Enter placeholder text...", "havenlytics")}
            id="hvnly_searchPlaceholder"
          />
        </div>

        <div className={styles['hvnly-settings-api__form-group']}>
          <label className={styles['hvnly-settings-api__form-label']}>
            {__("Search Radius (km)", "havenlytics")}
          </label>
          <input
            type="number"
            className={styles['hvnly-settings-api__form-control']}
            value={settings.hvnly_searchRadius}
            onChange={(e) => handleInputChange('hvnly_searchRadius', parseInt(e.target.value))}
            min="1"
            max="500"
            id="hvnly_searchRadius"
          />
        </div>
      </Card>

      <TabActionButtons
        onSave={handleSave}
        onReset={handleReset}
        showToast={showToast}
        saveLabel={__("Save Search Settings", "havenlytics")}
        resetLabel={__("Reset Changes", "havenlytics")}
      />
    </div>
  );
};

export default SearchSettings;